import Cfg from '../config/cfg';
import Deferred from '../models/deferred';
import { prettifyReportData, prettifyAnalyticsPayload } from '../utils/ctx';

export default {
  _deferredCtxInit: false,
  autoInitCtxManager: function(){
    var deferred = new Deferred();
    if(this._deferredCtxInit){
      return Promise.resolve();
    }
    this._deferredCtxInit = true;
    Flybits.Session.ready.then(function(){
      if(typeof window.Flybits === 'object' && !Flybits.context.Manager.isReporting){
        Flybits.context.Manager.reportDelay = Cfg.DEFAULTCTXREPORTINTERVAL;
        Flybits.context.Manager.initialize().then(function(){
          deferred.resolve();
        });
      } else{
        deferred.resolve();
      }
    }).catch(function(err){
      deferred.reject(err);
    });
    return deferred.promise;
  },
  handleContextPayload: function(payload, logger){
    logger = logger || console;
    var deferred = new Deferred();
    if(Array.isArray(payload)){
      Flybits.context.Manager.ready.then(function(){
        var ctxReportPromises = [];
        payload.forEach(function(ctxRep){
          if(ctxRep.pluginId && ctxRep.values){
            var cleansedValueObj = {};
            Object.keys(ctxRep.values).forEach(function(key){
              var cleansedKeyStr = key.replaceAll('query.','');
              cleansedValueObj[cleansedKeyStr] = ctxRep.values[key];
            });
            ctxReportPromises.push(Flybits.context.Manager.reportCtx(ctxRep.pluginId,cleansedValueObj));
          } else{
            logger.error('[ctxapi] malformed ctx payload object', payload);      
          }
        })
        Promise.allSettled(ctxReportPromises).then(function(results){
          if(results.some(result => result.status === 'rejected')){
            deferred.reject(new Error('[ctxapi] failed to report ctx payload', payload));
          } else{
            deferred.resolve(prettifyReportData(payload));
          }
        }).catch(function(err){
          deferred.reject(err);
        });
      })
    } else{
      logger.error('[ctxapi] malformed ctx payload', payload);
      deferred.reject(new Error('[ctxapi] malformed ctx payload', payload));
    }

    return deferred.promise;
  },
  handleAnalyticsPayload: function(payload, logger){
    var deferred = new Deferred();
    logger = logger || console;
    if(!payload?.contentInfo?.id){
      logger.error('[ctxapi] missing content id in analytics event');
      return Promise.reject(new Error('[ctxapi] missing content id in analytics event'));
    }

    if((payload.type === 'viewed' || payload.type === 'engaged') && !payload.component){
      Flybits.context.Manager.ready.then(function(){
        Flybits.analytics.Manager.reportContentID(payload.contentInfo.id,payload.type).then(function(){
          deferred.resolve(prettifyAnalyticsPayload(payload));
        }).catch(function(err){
          deferred.reject(err);
        });
      });
    } else if((payload.type === 'engaged' || payload.type === 'content_component_event') && payload.component){
      Flybits.context.Manager.ready.then(function(){
        Flybits.analytics.Manager.reportContentID(payload.contentInfo.id, Flybits.analytics.Manager.actions.COMPONENTENGAGED,{
          name: payload.component.name,
          compID: payload.component.id,
          type: payload.component.compId,
        }).then(function(){
          deferred.resolve(prettifyAnalyticsPayload(payload));
        }).catch(function(err){
          deferred.reject(err);
        });
      });
    } else{
      logger.error('[ctxapi] unsupported analytics event', payload);
      deferred.reject(new Error('[ctxapi] unsupported analytics event', payload));
    }

    return deferred.promise;
  }
}